import React from 'react'
import {Grid, Row, Col} from 'react-flexbox-grid'
import {FormattedRelative} from 'react-intl'
import {Link} from 'react-router'

import _ from 'lodash'

import {Breadcrumb, Icon, Menu} from 'antd'

import {DeviceStore} from 'api/device'
import {QueryService, MessageStore} from 'api/message'

import {DeviceStorage} from 'storage'

import {NotFound} from 'pages/NotFound'

import {Overview} from './overview'
import {Console} from './console'
import {Query} from '../query'
import {Configuration} from './configuration'

const buildPath = (parent, dest, {routes, params}) => {
   let parentRoutes = _.dropRightWhile(routes, ({component}) => !_.eq(parent, component)),
      path = _.map(parentRoutes, comp => comp.path).concat([dest]).join('/').replace(/\/\//, '/')

   return _.reduce(params, (acc, newVal, val) => acc.replace(':' + val, newVal), path)
}

const DeviceMeta = ({device}) => {
   if (!device) {
      return null
   }

   return (
      <ol>
         {device.meta.updated &&
            <li key="updated" style={{marginLeft: '1rem', display: 'inline', lineHeight: '46px'}}>
               <small>Updated: <FormattedRelative value={device.meta.updated} /></small>
            </li>}
         {device.meta.created &&
            <li key="created" style={{marginLeft: '1rem', display: 'inline', lineHeight: '46px'}}>
               <small>Created: <FormattedRelative value={device.meta.created} /></small>
            </li>}
      </ol>
   )
}

DeviceMeta.propTypes = {
   device: React.PropTypes.object
}

export class Device extends React.Component {
   static get propTypes() {
      return {
         network:  React.PropTypes.object,
         params:   React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         children: React.PropTypes.element.isRequired
      }
   }

   static get defaultProps() {}

   constructor() {
      super()

      this.state = {
         messages: [],
         stream:   null
      }

      this.handleClick = this.handleClick.bind(this)

      this.onMessage = this.onMessage.bind(this)
      this.openStream = this.openStream.bind(this)
   }

   onMessage(msg) {
      this.setState(state => {
         let sorted = _.sortByOrder(
            state.messages.concat([MessageStore.augment(msg)]),
            ['datetime'],
            ['desc']
         )

         return _.set(state, 'messages', sorted.slice(0, 1000))
      })
   }

   componentWillMount() {
      this._mounted = true

      this.openStream()
   }

   openStream() {
      if (!this._mounted) {
         return
      }

      let {params} = this.props,
         resource = params.nid + '/' + params.key,
         query = {
            'date.from': 'NOW//-1HOUR',
            limit:       100
         }

      QueryService.stream(resource, query, this.onMessage, false)
         .then(({xhr}) => {
            this.setState({queryStream: xhr})
         })
         .catch(_err => {
            console.log('stream closed, restarting in 1 second')
            setTimeout(this.openStream, 1000)
         })
   }

   componentWillUnmount() {
      this._mounted = false

      if (this.state.queryStream) {
         this.state.queryStream.abort()
         this.setState({queryStream: null})
      }
   }

   handleClick(ev) {
      const nextPath = ev.key.match(/^\//) ? ev.key : buildPath(Device, ev.key, this.props)

      this.props.router.push(nextPath)
   }

   render() {
      const {network, children, ...props} = this.props,
         {messages, queryStream} = this.state

      let params = props.params,
         subpath = props.routes[props.routes.length - 2].path,
         [routes, active] = _.dropWhile(props.routes, ({path}) => path !== subpath)

      if (!network) {
         return <NotFound />
      }

      const deviceName = ({nid, key}) => _.get(DeviceStore.device(nid, key), 'name', undefined)

      return (
         <div className="device">
            <div className="nav device-nav">
               <Grid>
                  <Row>
                     <Col xs={12} md={9}>
                        <Menu
                           mode="horizontal"
                           selectedKeys={[active.path]}
                           onClick={this.handleClick}
                        >

                           {_.map(routes.childRoutes, (child, _idx) => {
                              return !child.name ||
                                 (undefined !== child.show && child.show(network))
                                 ? null
                                 : <Menu.Item key={child.path}>
                                      <Link
                                         to={
                                            child.path.match(/^\//)
                                               ? child.path
                                               : buildPath(Device, child.path, {
                                                  routes: props.routes,
                                                  params
                                               })
                                         }
                                      >
                                         {child.glyph &&
                                            <Icon
                                               type={child.glyph}
                                               style={{marginRight: '1.5rem'}}
                                            />}
                                         {child.name}
                                      </Link>
                                   </Menu.Item>
                           })}
                        </Menu>

                     </Col>
                     <Col xs={12} md={3}>
                        <DeviceStorage nid={network.key} device={params.key}>
                           <DeviceMeta />
                        </DeviceStorage>
                     </Col>
                  </Row>

                  <Row>
                     <Col>
                        <Breadcrumb>
                           <Breadcrumb.Item>
                              <Link to="/dashboard">
                                 <Icon type="left" style={{marginRight: '1.5rem'}} />
                                 All Networks
                              </Link>
                           </Breadcrumb.Item>
                           <Breadcrumb.Item>
                              <Link to={`/dashboard/network/${params.nid}/overview`}>
                                 Network: {network.name || 'Unnamed Network'}
                              </Link>
                           </Breadcrumb.Item>
                           <Breadcrumb.Item>
                              <Link to={`/dashboard/device/${params.nid}/${params.key}/overview`}>
                                 Device: {deviceName(params) || 'Unnamed Device'}
                              </Link>
                           </Breadcrumb.Item>
                        </Breadcrumb>
                     </Col>
                  </Row>
               </Grid>
            </div>
            <Grid>
               <Row>
                  <Col xs={12}>
                     <DeviceStorage
                        nid={network.key}
                        device={params.key}
                        network={network}
                        messages={messages}
                        queryStream={queryStream}
                     >
                        {children}
                     </DeviceStorage>

                  </Col>
               </Row>
            </Grid>
         </div>
      )
   }
}

Device.onEnter = (nextState, replace) => {
   if (_.last(nextState.routes).component === Device) {
      replace({pathname: buildPath(Device, 'overview', nextState)})
   }
}

Device.childRoutes = [
   {
      name:      'Overview',
      glyph:     'home',
      path:      'overview',
      component: Overview
   },
   {
      name:      'Configuration',
      glyph:     'setting',
      path:      'config',
      component: Configuration
   },
   {
      name:      'Query',
      glyph:     'search',
      path:      'query',
      component: Query
   },
   {
      name:      'Console',
      glyph:     'code',
      path:      'console',
      component: Console
   },
   {
      path:      '*',
      component: NotFound
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/index.js